import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Grid,
  Card,
  Chip,
  IconButton,
  Tooltip,
  Stack,
} from "@mui/material";
import { LuDownload } from "react-icons/lu";
import { useDispatch } from "react-redux";
import moment from "moment/moment";
import {
  getUserNotifications,
  updateNotification,
  bulkNotificationUpload,
} from "../../../api/notificationService";
import { notificationType, scheduleType } from "../../../configs/constants";
import TableCompo from "../Table/TableCompo";
import { RiDeleteBin6Line, RiEdit2Fill } from "react-icons/ri";
import { MdNotificationsActive, MdSchedule } from "react-icons/md";
import { IoAdd } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import auth from "../../../configs/auth";
import useCsvConverter from "../../../hooks/convertToCSV";
import { apiRequest } from "../../../redux/Reports/reportsSlice";
import { canShowPermission } from "../Permissions/permissionObject";

const getNotificationEstimatedRowHeight = (params) => {
  const row = params?.row || params?.model || {};
  const body = row.body || "";
  const title = row.title || "";
  const bodyLines = String(body).split("\n").length;
  const titleLines = Math.max(1, Math.ceil(title.length / 40));
  const bodyHeight = bodyLines * 24 + 28;
  const titleHeight = titleLines * 22 + 20;
  return Math.max(bodyHeight, titleHeight, 52);
};

export default function Notification() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("adminUserData"));
  const [image, setImage] = useState(null);
  const [csvFile, setCsvFile] = useState(null);
  const [notificationList, setNotificationList] = useState([]);
  const [total, setTotal] = useState(0);
  // const [open, setOpen] = useState(false)
  // const [update, setUpdate] = useState(false);
  // const [selectedRow, setSelectedRow] = useState(null);

  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const jeweller = sessionStorage.getItem(auth.selectedJeweller);
  const jewellerID = storedUser?.jeweller;
  const finalJewellerId =
    jeweller && jeweller.trim() !== "" ? jeweller : jewellerID;

  const handleSubmit = () => {
    console.log("Selected Image:", image);
    console.log("CSV File:", csvFile);

    alert("Data ready for API submission or previewed in console.");
  };

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [searchText, setSearchText] = useState("");

  async function getNotifications({
    page: pageArg = 0,
    limit: limitArg = 10,
    search = "",
  } = {}) {
    const response = await getUserNotifications({
      jeweller: finalJewellerId,
      user: userData._id,
      notificationType: notificationType.admin,
      page: pageArg + 1, // backend is 1-based
      limit: limitArg,
      search,
    });

    if (response.success) {
      setNotificationList(Array.isArray(response.data) ? response.data : []);
      setTotal(response.total || 0);
    }
  }

  useEffect(() => {
    if (!finalJewellerId || !userData?._id) return;
    getNotifications({ page, limit, search: searchText });
  }, [finalJewellerId, userData?._id, page, limit, searchText]);

  // useEffect(()=>{
  //   if(selectedRow){
  //     setUpdate(true)
  //   }
  // },[selectedRow])

  async function handleDelete(id) {
    let confirm = window.confirm("Are u sure want to delete?");
    if (confirm) {
      let res = await updateNotification({ id: id, enabled: false });
      alert(res.message);
      await getNotifications({ page, limit, search: searchText });
    }
  }

  // Bulk Notification  function
  const handleBulkNotificationSend = async () => {
    console.log("image", image);
    if (!image) {
      alert("Please upload file");
      return;
    }

    const formData = new FormData();
    formData.append("notificationfile", image);

    try {
      const res = await bulkNotificationUpload(formData);
      alert(res.message);
      setImage(null);
    } catch (err) {
      console.error(err);
    }
  };

  const [permissions, setPermissions] = useState({});
  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (error) {
        console.error("Error parsing stored permissions", error);
      }
    }
  }, []);
  const canCreateNotification = canShowPermission(
    permissions,
    "customNotification",
    "create",
  );
  const canEditNotification = canShowPermission(
    permissions,
    "customNotification",
    "edit",
  );
  const canDeleteNotification = canShowPermission(
    permissions,
    "customNotification",
    "delete",
  );

  const columns = [
    {
      field: "title",
      headerName: "Notification Title",
      minWidth: 260,
      flex: 1.4,
      alignTop: true,
      render: (value) => (
        <Box sx={{ width: "100%", py: 0.5 }}>
          <Typography
            component="div"
            fontWeight={700}
            fontSize="0.875rem"
            color="#1a1a2e"
            sx={{
              lineHeight: 1.6,
              wordBreak: "break-word",
              whiteSpace: "normal",
              overflow: "visible",
            }}
          >
            {value || "—"}
          </Typography>
        </Box>
      ),
    },
    {
      field: "body",
      headerName: "Notification Content",
      minWidth: 380,
      flex: 2.2,
      alignTop: true,
      render: (value) => (
        <Box
          component="div"
          sx={{
            width: "100%",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            lineHeight: 1.7,
            fontSize: "0.84rem",
            color: "#374151",
            background: "#f8f7ff",
            border: "1px solid #ebe6f7",
            borderRadius: "10px",
            px: 1.5,
            py: 1,
            overflow: "visible",
          }}
        >
          {value || "—"}
        </Box>
      ),
    },
    {
      field: "scheduleType",
      headerName: "Schedule Type",
      minWidth: 130,
      flex: 0.7,
      render: (value) => {
        const isNow =
          value === scheduleType.now || String(value).toLowerCase() === "now";
        return (
          <Chip
            size="small"
            label={isNow ? "Send Now" : "Scheduled"}
            sx={{
              fontWeight: 600,
              fontSize: "0.75rem",
              background: isNow ? "#e8f5e9" : "#fff3e0",
              color: isNow ? "#2e7d32" : "#e65100",
              border: `1px solid ${isNow ? "#a5d6a7" : "#ffcc80"}`,
            }}
          />
        );
      },
    },
    {
      field: "scheduleAt",
      headerName: "Schedule At",
      minWidth: 170,
      flex: 0.9,
      render: (value, row) => (
        <Stack direction="row" alignItems="center" spacing={0.75}>
          <MdSchedule size={16} color="#752ADA" />
          <Typography fontSize="0.84rem" color="#374151" fontWeight={500}>
            {moment(row.scheduleAt).format("DD-MM-YYYY hh:mm A")}
          </Typography>
        </Stack>
      ),
    },
    {
      field: "noti",
      headerName: "Status",
      minWidth: 110,
      flex: 0.6,
      render: (value, row) => (
        <Chip
          size="small"
          label={row.isNotificationSent ? "Sent" : "Pending"}
          sx={{
            fontWeight: 700,
            fontSize: "0.75rem",
            background: row.isNotificationSent ? "#e8f5e9" : "#f3f4f6",
            color: row.isNotificationSent ? "#2e7d32" : "#6b7280",
            border: `1px solid ${row.isNotificationSent ? "#a5d6a7" : "#e5e7eb"}`,
          }}
        />
      ),
    },
    {
      field: "delete",
      headerName: "Action",
      minWidth: 100,
      flex: 0.5,
      sortable: false,
      render: (value, row) => (
        <Stack direction="row" spacing={0.5}>
          {!row.isNotificationSent && canEditNotification && (
            <Tooltip title="Edit">
              <IconButton
                size="small"
                onClick={() =>
                  navigate("/CreateNotification", {
                    state: {
                      header: "Update Notification",
                      titlename: "Title",
                      contentname: "Content",
                      notificationType: notificationType.admin,
                      button_name: "Update",
                      row,
                    },
                  })
                }
                sx={{
                  color: "#752ADA",
                  background: "#f3eaff",
                  "&:hover": { background: "#e8d9ff" },
                }}
              >
                <RiEdit2Fill size={16} />
              </IconButton>
            </Tooltip>
          )}

          {canDeleteNotification && (
            <Tooltip title="Delete">
              <IconButton
                size="small"
                onClick={() => handleDelete(row._id)}
                sx={{
                  color: "#d32f2f",
                  background: "#fdecea",
                  "&:hover": { background: "#f9d5d2" },
                }}
              >
                <RiDeleteBin6Line size={16} />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      ),
    },
  ];

  const { convertToCsv } = useCsvConverter();

  const triggerCsvDownload = (csvText, filename) => {
    const blob = new Blob([csvText], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();

    window.URL.revokeObjectURL(url);
  };

  const handleDownloadCsv = () => {
    console.log("Store CSV API called");

    dispatch(
      apiRequest({
        method: "GET",
        endpoint: `/api/v1/notification/notificationCsv/${finalJewellerId}/${userData._id}`,
        query: {},
        callback: (response) => {
          const csv = convertToCsv(response?.data || []);
          triggerCsvDownload(csv, "notification.csv");
        },
      }),
    );
  };

  const handleTableChange = (type, payload) => {
    if (type === "changePage") {
      setPage(payload.page);
    }

    if (type === "changeRowsPerPage") {
      setLimit(payload.rowsPerPage);
      setPage(0);
    }

    if (type === "search") {
      setSearchText(payload.searchText);
      setPage(0);
    }
  };

  return (
    <Box sx={{ display: "flex", background: "#f3f3fd" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: "100%",
          overflow: "auto",
          height: "100vh",
          p: 2,
          mt: 5,
        }}
      >
        <Paper
          sx={{ p: { xs: 2, sm: 3 }, mb: 2, borderRadius: "16px", width: "100%" }}
          elevation={0}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: { xs: "flex-start", sm: "center" },
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              mb: 1,
            }}
          >
            <Box display="flex" alignItems="center" gap={1.5}>
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "12px",
                  background: "linear-gradient(135deg, #752ADA 0%, #9b4dff 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                }}
              >
                <MdNotificationsActive size={22} />
              </Box>
              <Box>
                <Typography fontWeight={700} fontSize={22} fontFamily="Aeonik" color="#1a1a2e">
                  Notifications
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Manage and track sent notifications
                </Typography>
              </Box>
            </Box>

            {canCreateNotification && (
              <Button
                variant="contained"
                startIcon={<IoAdd />}
                onClick={() =>
                  navigate("/CreateNotification", {
                    state: {
                      header: "Create Notification",
                      titlename: "Title",
                      contentname: "Content",
                      notificationType: notificationType.admin,
                    },
                  })
                }
                sx={{
                  background: "linear-gradient(135deg, #752ADA 0%, #9b4dff 100%)",
                  textTransform: "none",
                  borderRadius: "10px",
                  px: 2.5,
                  py: 1,
                  boxShadow: "0 4px 14px rgba(117, 42, 218, 0.3)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #5f1fb8 0%, #7a3dd4 100%)",
                  },
                }}
              >
                Create Notification
              </Button>
            )}
          </Box>

          <TableCompo
            columns={columns}
            data={notificationList}
            page={page}
            limit={limit}
            totalCount={total}
            onTableChange={handleTableChange}
            multiline
            estimatedRowHeight={getNotificationEstimatedRowHeight}
            extraButtons={
              <Button
                size="sm"
                variant="outlined"
                onClick={handleDownloadCsv}
                sx={{
                  textTransform: "none",
                  borderColor: "#752ADA",
                  color: "#752ADA",
                  borderRadius: "8px",
                }}
              >
                Download CSV
              </Button>
            }
          />
        </Paper>
        {/* <CustomModal setOpen={setOpen} open={open} content={<CreateNotification onSave={setOpen} notificationType={notificationType.admin} header={"Create Notification"} titlename={"Title"} contentname={"Content"} />} />
        <CustomModal setOpen={setUpdate} open={update} content={<CreateNotification onSave={setUpdate} notificationType={notificationType.admin} header={"Update Notification"} button_name="Update" titlename={"Title"} contentname={"Content"} row={selectedRow} />} /> */}

        {/* CSV Upload Section */}
        <Card
          elevation={3}
          sx={{
            p: 2,
            width: "100%",
            maxWidth: "100%",
            borderRadius: "16px",
            mt: 4,
          }}
        >
          <Typography
            fontWeight={700}
            fontSize={24}
            mb={3}
            fontFamily={"Aeonik"}
          >
            {" "}
            Upload file
          </Typography>
          <Typography
            variant="body2"
            gutterBottom
            sx={{ mb: "10px", color: "#606778" }}
          >
            Select CSV File
            <span style={{ color: "#c1c1c1" }}>
              {" "}
              (Note: The xlsx file must include headers - phone, title, and
              content for each phone number)
            </span>
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {/* Choose csv file button */}
              <Button
                variant="outlined"
                component="label"
                sx={{ color: "#752ADA", border: "1px solid #752ada" }}
              >
                <LuDownload style={{ marginRight: 8 }} />
                Choose File
                <input
                  type="file"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  hidden
                  onChange={(e) => setImage(e.target.files[0])}
                />
              </Button>
            </Grid>
            {image && (
              <Grid item xs={12}>
                <Typography
                  variant="body2"
                  sx={{
                    mt: 1,
                    background: "#f3f3fd",
                    padding: "6px 10px",
                    borderRadius: "8px",
                    display: "inline-block",
                  }}
                >
                  📄 {image.name}
                </Typography>
              </Grid>
            )}
          </Grid>

          <Box mb={4} display="flex" justifyContent="center">
            {/* Generate  button */}
            {canCreateNotification && (
              <Button
                variant="contained"
                sx={{
                  background: "#752ADA",
                  fontSize: "16px",
                  mt: 2,
                  px: 3,
                  textTransform: "none",
                }}
                onClick={handleBulkNotificationSend}
              >
                Upload
              </Button>
            )}
          </Box>
        </Card>
      </Box>
    </Box>
  );
}
